export const Formatter = {
  regNumFormat: (val: any) => {
    if (val === "") return "";
    const txtLeng = val.length;

    const prefix = val.substring(0, 3);
    const midfix = val.substring(3, 5);
    const suffix = val.substring(5, 10);

    if (txtLeng < 4) {
      return `${prefix}`;
    } else if (txtLeng >= 4 && txtLeng < 6) {
      return `${prefix}-${midfix}`;
    } else {
      return `${prefix}-${midfix}-${suffix}`;
    }
  },

  phoneNumFormat: (val: any) => {
    if (val === "") return "";
    const txtLeng = val.length;

    const prefix = val.substring(0, 3);
    const midfix = val.substring(3, 7);
    const suffix = val.substring(7, 11);

    if (txtLeng < 4) {
      return `${prefix}`;
    } else if (txtLeng >= 4 && txtLeng < 8) {
      return `${prefix}-${midfix}`;
    } else {
      return `${prefix}-${midfix}-${suffix}`;
    }
  },

  newPhoneNumFormat: (val: string) => {
    if (val === "") return "";

    const txtLeng = val.length;
    const prefix = val.substring(0, 3);
    let midfix = "";
    let suffix = "";

    if (prefix === "010") {
      midfix = val.substring(3, 7);
      suffix = val.substring(7, 11);
    } else {
      midfix = val.substring(3, 6);
      suffix = val.substring(6, 10);
    }

    if (val.length < 4) {
      return val;
    } else if (prefix === "010" && val.length < 8) {
      return `${prefix}-${midfix}`;
    } else if (val.length < 7) {
      return `${prefix}-${midfix}`;
    } else {
      return `${prefix}-${midfix}-${suffix}`;
    }
  },
};
